import React from 'react'
import useReduxData from './useReduxData'
import { constant_store_info } from '../constant/constant_seo_info'
const useSeoData = () => {
    const {store:{selectedStore:{
        store_name,
        description,
        banner_image,
        favicon,
    }}}=useReduxData()
    return {
        title:store_name || constant_store_info.title ,
        description:description || constant_store_info.description,
        keyboard:constant_store_info.keywords,
        author:"YOP",
        image:banner_image ? (banner_image?.base_url + banner_image?.attachment_url):constant_store_info.image,
        logo:favicon ? (favicon?.base_url + favicon?.attachment_url) : constant_store_info.logo
    }
}

export default useSeoData